import React, { useEffect, useRef, useState } from "react";

import DataTable from "datatables.net-react";
import DT from "datatables.net-bs5";

import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-buttons-bs5/css/buttons.bootstrap5.min.css";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css"; // Responsive CSS

import "datatables.net-bs5";
import "datatables.net-buttons-bs5";
import "datatables.net-responsive-bs5"; // Responsive JS
import "datatables.net-buttons/js/buttons.html5.min.js";
import "datatables.net-buttons/js/buttons.print.min.js";
import "datatables.net-buttons/js/buttons.colVis.min.js";
import "jszip";
import "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";
import $ from "jquery";
import "./VendorLeadDataTableCSS.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import NotifyMessageNoReload from "../../../Others/NotifyMessageNoReload";
import APIDataFetchLoader from "../../../Others/APIDataFetchLoader";
import { useAuth } from "../../../../Store/AuthContext";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Input,
} from "@mui/material";
import NotifyTopMSGNoReload from "../../../Others/NotifyTopMSGNoReload";
// import { AllGETWorkingLeads } from "../../../FetchAPI";

DataTable.use(DT);

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function LeadWorkingDataTable() {
  const { userID, RendomTokenfetch, userRoll, vendorRollID } = useAuth();

  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [leadPrice, setLeadPrice] = useState("");
  const [leadpricUpdateID, setLeadpricUpdateID] = useState("");
  const [openPriceUpdateModal, setOpenPriceUpdateModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedLeadIDs, setSelectedLeadIDs] = useState([]);
  const [LeadStatusOptoion, setLeadStatusOptoion] = useState([]);
  const [VendorLeads, setVendorLeads] = useState([]);
  // console.log(VendorLeads);
  const [vendorStatus, setvendorStatus] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [Filterloading, setFilterloading] = useState(false);
  const tableRef = useRef(null);

  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    workStatus: "",
  });
  const filtersRef = useRef(filters);

  // *********Fetch Vendor Status on component mount********
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("user_id", userID);
    fdata.append("vendor_role", vendorRollID);
    const FetchVendorStatusData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}vendorstatusshow`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setvendorStatus(response.data.statusdata || []);
            }
            if (response.data.Status === "0") {
              setvendorStatus([]);
            }
          });
      } catch (err) {
        console.log(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchVendorStatusData();
  }, [RendomTokenfetch, userID, vendorRollID]);

  const [tempFilters, setTempFilters] = useState(filters);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setTempFilters((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    filtersRef.current = filters;

    const tableInstance = tableRef.current?.dt();
    if (tableInstance) {
      setFilterloading(true); // Show loader
      // console.log("Reloading with filters:", filtersRef.current);

      tableInstance.ajax.reload(() => {
        setFilterloading(false); // Hide loader after reload finishes
      });
    }
  }, [filters]);
  const handleFilterSubmit = (e) => {
    e.preventDefault();
    setFilters(tempFilters); // triggers reload through useEffect
  };

  const newspaperClearFilter = () => {
    const clearedFilters = {
      startDate: "",
      endDate: "",
      workStatus: "",
    };
    setTempFilters(clearedFilters);
    setFilters(clearedFilters); // useEffect will handle reload
  };

  //*******Handle All Status Select Option********
  function parseLeadStatusOptions(optionHTMLArray) {
    return optionHTMLArray.map((html) => {
      const div = document.createElement("div");
      div.innerHTML = html;
      const option = div.querySelector("option");
      return {
        value: option?.value || "",
        label: option?.textContent || "",
      };
    });
  }

  //*********Handle All Datatable Colomn**********
  const columns = [
    {
      title: `<input type="checkbox" id="selectAll" />`, // Header checkbox
      data: null,
      orderable: false,
      searchable: false,
      render: (data, type, row) => {
        return `<input type="checkbox" class="row-checkbox" data-id="${row.id}" />`;
      },
    },
    {
      title: "Lead Number",
      data: "id",
    },
    {
      title: "Applicant Name",
      data: "name",
      render: (data, type, row) => {
        return row.vendor_accept_status === "1" &&
          row.a_lead_price_verification === "1"
          ? `<span  data-id="${row.id}" class="lead-link fw-600" style="color: blue; cursor: pointer;" title="View">${data}</span>`
          : `<span class="text-muted">${data}</span>`;
      },
    },
    {
      title: "Lead Status",
      data: "status",
      render: (data, type, row) => {
        return `<span class="badge" style="color:${row.statuscolor};background-color:${row.statusbg};">${data}</span>`;
      },
    },
    {
      title: "In Status Days",
      data: "lead_status_days_count",
      render: (data, type, row) => {
        return `<span class="badge bg-primary">${data}</span>`;
      },
    },
    { title: "Service", data: "service" },
    { title: "Old Name", data: "old_name" },
    { title: "New Name", data: "new_name" },
    { title: "Start Date", data: "date" },
    {
      title: "Accept Status",
      data: "vendor_accept_status",
      render: function (data, type, row) {
        if (row.a_lead_price_verification === "1") {
          if (data === "0") {
            return `
            <select class="form-select form-select-sm lead-status-dropdown" data-id="${row.id}" >
              <option value="1">Accepted</option>
              <option value="0" selected>Not Accepted</option>
              <option value="2">Reject/Return</option>
            </select>
          `;
          } else {
            const badgeClass = data === "1" ? "bg-success" : "bg-danger";
            const badgeText = data === "1" ? "Accepted" : "Rejected";
            return `<span class="badge ${badgeClass}" >${badgeText}</span>`;
          }
        } else {
          return "";
        }
      },
    },

    { title: "Accept Date", data: "vendor_accept_date" },
    {
      title: "Agent Price",
      data: "a_lead_price",
      render: function (data, type, row) {
        return data !== "" ? `<span class="text-primary"> ₹${data}</span>` : "";
      },
    },
    {
      title: "Agent Price Status/Update",
      data: "a_pricestatusname",
      render: function (data, type, row) {
        if (row.a_lead_price !== "") {
          if (row.a_lead_price_verification === "1") {
            return `<span class="badge bg-success" >${data}</span>`;
          } else if (row.a_lead_price_verification === "0") {
            return `<span class="badge bg-danger" >${data}</span>`;
          } else {
            return `<span class="badge bg-warning" >${data}</span>`;
          }
        } else {
          return `<span data-id="${row.id}" class="newspaperEditbtn leadPriceUpdate" style="cursor: pointer;" title="Lead Price Update">
           <i class="text-light fa fa-pencil-square-o" aria-hidden="true"></i>
         </span>`;
        }
      },
    },
    // {
    //   title: "Lead Price Update",
    //   data: "a_lead_price_verification",
    //   render: (data, type, row) => {
    //     return data === "1"
    //       ? `<span class="newspaperEditbtn" style="background-color: gray;" title="Lead Price Update">
    //        <i class="text-light fa fa-pencil-square-o" aria-hidden="true"></i>
    //      </span>`
    //       : `<span data-id="${row.id}" class="newspaperEditbtn leadPriceUpdate" style="cursor: pointer;" title="Lead Price Update">
    //        <i class="text-light fa fa-pencil-square-o" aria-hidden="true"></i>
    //      </span>`;
    //   },
    // },
  ];

  //********Handle All Links data Update,fetch ETC********
  useEffect(() => {
    const handleSelectAll = function () {
      const isChecked = $(this).is(":checked");
      $(".row-checkbox").prop("checked", isChecked);
    };
    const handleRowCheckbox = function () {
      const allChecked =
        $(".row-checkbox").length === $(".row-checkbox:checked").length;
      $("#selectAll").prop("checked", allChecked);
    };

    // Handle Lead status update

    // Handle Update button click
    $(document).on("click", ".handleServiceStatus", async function (e) {
      e.preventDefault();

      const selectedIDs = $(".row-checkbox:checked")
        .map(function () {
          return $(this).data("id");
        })
        .get();

      // alert(selectedIDs);
      if (selectedIDs.length === 0) {
        NotifyTopMSGNoReload("Please select at least one row!", "warning");
        return;
      }

      setSelectedLeadIDs(selectedIDs);
      // setOpenStatusModal(true);

      // Modle Open Bebore Call Status Option APi
      let fdata = new FormData();
      fdata.append("user_id", userID);
      fdata.append("vendor_type", vendorRollID);
      fdata.append("leadids", selectedIDs);

      try {
        setLoading(true);
        const response = await axios.post(
          `${WebsiteAPIurl}checkLeadService`,
          fdata,
          {
            headers: {
              Authorization: RendomTokenfetch,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        // console.log(response.data);
        if (response.data.Status === "1") {
          const parsedOptions = parseLeadStatusOptions(
            response.data.selectoptions
          );
          setLeadStatusOptoion(parsedOptions);
          setOpenStatusModal(true);
          // NotifyMessageNoReload(response.data.message, "success");
        } else {
          NotifyMessageNoReload(response.data.message, "danger");
        }
      } catch (error) {
        console.error("Error Claiming Lead:", error);
      } finally {
        setLoading(false);
      }
    });

    // Handle Vendor Accept Status
    const handleStatusChange = async function (e) {
      e.preventDefault();
      const $select = $(this);
      const leadId = $select.data("id");
      const newStatus = $select.val();
      const previousStatus = $select.data("previous-value");

      const confirmClaim = window.confirm(
        "Are you sure you want to change status?"
      );

      if (!confirmClaim) {
        $select.val(previousStatus); // revert to previous
        return;
      }

      let fdata = new FormData();
      fdata.append("role_id", userRoll);
      fdata.append("userid", userID);
      fdata.append("leadid", leadId);
      fdata.append("vendor_accept_status", newStatus);

      try {
        setLoading(true);
        const response = await axios.post(
          `${WebsiteAPIurl}vendorrequestupdate`,
          fdata,
          {
            headers: {
              Authorization: RendomTokenfetch,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data.Status === "1") {
          NotifyMessageNoReload(response.data.message, "success");
        } else {
          NotifyMessageNoReload(response.data.message, "danger");
        }
      } catch (error) {
        console.error("Error Claiming Lead:", error);
      } finally {
        setLoading(false);
      }
    };

    const handleRowClick = function (event) {
      const leadId = $(this).data("id");
      const rowData = VendorLeads.find((lead) => lead.id.toString() === leadId);
      if (rowData?.vendor_accept_status === "0") return;
      navigate(`/lead-working-details/${leadId}`, { replace: false });
    };

    $(document).on("focus", ".lead-status-dropdown", function () {
      const previousVal = $(this).val();
      $(this).data("previous-value", previousVal);
    });

    $(document).on("click", ".leadPriceUpdate", function () {
      const leadId = $(this).data("id");
      setLeadPrice("");
      setLeadpricUpdateID(leadId);
      setOpenPriceUpdateModal(true);
    });

    $(document).off("change", ".lead-status-dropdown", handleStatusChange);
    $(document).on("change", ".lead-status-dropdown", handleStatusChange);
    $(document).on("change", "#selectAll", handleSelectAll);
    $(document).on("change", ".row-checkbox", handleRowCheckbox);
    $(document).on("click", ".lead-link", handleRowClick);

    return () => {
      $(document).off("change", ".lead-status-dropdown", handleStatusChange);
      $(document).off("focus", ".lead-status-dropdown");
      $(document).off("click", ".handleServiceStatus");
      $(document).off("click", ".leadPriceUpdate");
      $(document).off("change", "#selectAll", handleSelectAll);
      $(document).off("change", ".row-checkbox", handleRowCheckbox);
      $(document).off("click", ".lead-link", handleRowClick);
    };
  }, [
    navigate,
    VendorLeads,
    userID,
    RendomTokenfetch,
    userRoll,
    selectedLeadIDs,
    vendorRollID,
  ]);

  if (loading || Filterloading) {
    return <APIDataFetchLoader />;
  }

  return (
    <>
      <>
        {/* ************Filter HTML********* */}
        <div className="row">
          <div className="col-lg-12">
            <div className="ls-widget">
              <div className="tabs-box">
                <div className="widget-title  px-2 py-1 newsvendorfliderheading">
                  <p className="mb-0">FILTER BY</p>
                </div>
                <div className="widget-content p-3">
                  <form className="was-validated" onSubmit={handleFilterSubmit}>
                    <div className="row">
                      <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                        <label htmlFor="startDate">Start Date</label>
                        <input
                          type="date"
                          className="form-control"
                          name="startDate"
                          value={tempFilters.startDate}
                          onChange={handleFilterChange}
                        />
                      </div>
                      <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                        <label htmlFor="endDate">End Date</label>
                        <input
                          type="date"
                          className="form-control"
                          name="endDate"
                          value={tempFilters.endDate}
                          onChange={handleFilterChange}
                        />
                      </div>
                      <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                        <label>Lead Status</label>
                        <select
                          className="chosen-select form-control"
                          name="workStatus"
                          value={tempFilters.workStatus}
                          onChange={handleFilterChange}
                        >
                          <option value="">Select</option>
                          {vendorStatus.map((val) => (
                            <option value={val.id} key={val.id}>
                              {val.lead_status}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12 text-center mt-3">
                      <button className="theme-btn btn-style-three submitbtn">
                        Submit
                      </button>
                      <span
                        className="mx-4 theme-btn btn-style-three submitbtn"
                        onClick={newspaperClearFilter}
                      >
                        Clear Filter
                      </span>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* *******DataTable********* */}
        <div className="row">
          <div className="col-lg-12">
            <div className="ls-widget mb-0">
              <div className="tabs-box">
                <div
                  className="widget-content py-3 table-responsive"
                  style={{ overflowX: "auto" }}
                >
                  <div className="newspapermultyupdatebox">
                    <div className="row my-1">
                      <div className="col-lg-12 col-md-12 text-end mt-1">
                        <button className="theme-btn btn-style-three submitbtn handleServiceStatus">
                          <span>
                            <i className="fa fa-edit me-2"></i>
                          </span>{" "}
                          Update Status
                        </button>
                      </div>
                    </div>
                  </div>
                  <DataTable
                    className="table table-striped table-bordered vendordatatable"
                    ref={tableRef}
                    columns={columns}
                    responsive={true}
                    noHeader={true}
                    style={{ tableLayout: "auto", width: "100%" }}
                    processing={true}
                    options={{
                      responsive: false,
                      ordering: false,
                      scrollX: true,
                      dom: "Bfrtip",

                      buttons: [
                        {
                          extend: "copy",
                          text: `<i class="fa fa-clone"></i>`,
                          className: "btn btn-sm",
                          titleAttr: "Copy to clipboard",
                          exportOptions: {
                            columns: ":visible",
                          },
                        },
                        {
                          extend: "excelHtml5",
                          text: `<i class="fa fa-file-excel-o"></i>`,
                          className: "btn btn-sm",
                          titleAttr: "Export to Excel",
                          exportOptions: {
                            columns: ":visible",
                          },
                        },
                        {
                          extend: "pdfHtml5",
                          text: `<i class="fa fa-file-pdf-o"></i>`,
                          className: "btn btn-sm",
                          titleAttr: "Export to PDF",
                          exportOptions: {
                            columns: ":visible",
                          },
                        },
                        {
                          extend: "print",
                          text: '<i class="fa fa-print"></i>',
                          className: "btn btn-sm",
                          titleAttr: "Print table",
                          exportOptions: {
                            columns: ":visible",
                            modifier: {
                              page: "all",
                            },
                          },
                        },
                        {
                          extend: "colvis",
                          text: "Column Visibility", // Boxicon for Column Visibility
                          className: "btn btn-sm",
                          titleAttr: "Toggle column visibility",
                        },
                        {
                          extend: "pageLength",
                          text: "Show Rows",
                          className: "btn btn-sm",
                          titleAttr: "Change Number of Rows Displayed",
                        },
                      ],
                      lengthMenu: [
                        [10, 50, 100, 150, 200, -1],
                        [10, 50, 100, 150, 200, "All"],
                      ],

                      colVis: {
                        restore: true,
                      },

                      stateSave: true,
                      deferRender: true,
                      scrollCollapse: true,
                      scroller: true,
                      pagingType: "full_numbers",
                      fixedHeader: true,
                      autoWidth: false,
                      serverSide: true,
                      paging: true,
                      pageLength: 10,
                      ajax: (data, callback) => {
                        const currentFilters = filtersRef.current;

                        const page = Math.floor(data.start / data.length) + 1;
                        const limit = data.length;

                        axios
                          .get(`${WebsiteAPIurl}allLeadsvendorworking`, {
                            params: {
                              user_id: userID,
                              start_date: currentFilters.startDate,
                              end_date: currentFilters.endDate,
                              status: currentFilters.workStatus,
                              page: page,
                              limit: limit,
                              search: data.search.value,
                            },
                            headers: { Authorization: RendomTokenfetch },
                          })
                          .then((res) => {
                            const r = res.data;

                            const total = parseInt(r.total_length) || 0;
                            const data = Array.isArray(r.leaddata)
                              ? r.leaddata
                              : [];

                            setVendorLeads(data);
                            callback({
                              data: r.leaddata,
                              recordsTotal: total,
                              recordsFiltered: total,
                            });
                          })
                          .catch(() =>
                            callback({
                              data: [],
                              recordsTotal: 0,
                              recordsFiltered: 0,
                            })
                          );
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>

      {/* MUI Modal Select Status Update*/}
      <Dialog
        open={openStatusModal}
        onClose={() => setOpenStatusModal(false)}
        PaperProps={{
          sx: {
            width: "512px",
            height: "250px",
            maxWidth: "90vw",
            maxHeight: "90vh",
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle>Update Lead Status</DialogTitle>
        <DialogContent>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Select Status</InputLabel>
            <Select
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
              label="Select Status"
            >
              {/* <MenuItem value="">Select Status</MenuItem> */}
              {LeadStatusOptoion.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenStatusModal(false)}
            color="secondary"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={async () => {
              if (!selectedStatus) {
                NotifyTopMSGNoReload("Please select a status", "warning");
                return;
              } else {
                const confirmClaim = window.confirm(
                  "Are you sure you want to change status?"
                );
                if (!confirmClaim) {
                  return;
                }
              }
              // console.log(selectedStatus);
              let fdata = new FormData();
              fdata.append("leadids", selectedLeadIDs.join(","));
              fdata.append("statusname", selectedStatus);
              fdata.append("user_id", userID);
              fdata.append("vendor_type", vendorRollID);

              try {
                setLoading(true);
                const response = await axios.post(
                  `${WebsiteAPIurl}multipleStatusUpdateAction`,
                  fdata,
                  {
                    headers: {
                      Authorization: RendomTokenfetch,
                      "Content-Type": "multipart/form-data",
                    },
                  }
                );

                if (response.data.Status === "1") {
                  NotifyMessageNoReload(response.data.message, "success");
                  setOpenStatusModal(false);
                  setSelectedStatus("");
                  setSelectedLeadIDs([]);
                } else {
                  NotifyMessageNoReload(response.data.message, "danger");
                }
              } catch (error) {
                console.error("Error updating lead status:", error);
              } finally {
                setLoading(false);
              }
            }}
            variant="contained"
            color="primary"
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>

      {/* ************* Lead Price Update ************* */}
      <Dialog
        open={openPriceUpdateModal}
        onClose={() => setOpenPriceUpdateModal(false)}
        PaperProps={{
          sx: {
            width: "512px",
            height: "250px",
            maxWidth: "90vw",
            maxHeight: "90vh",
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle>Agent Price </DialogTitle>
        <DialogContent>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Enter Price</InputLabel>
            <Input
              type="number"
              value={leadPrice}
              onChange={(e) => setLeadPrice(e.target.value)}
              label="Agent Price"
            ></Input>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenPriceUpdateModal(false)}
            color="secondary"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={async () => {
              if (!leadPrice) {
                NotifyTopMSGNoReload("Please Enter Vaild Price!", "warning");
                return;
              } else {
                const confirmLeadPrice = window.confirm(
                  "Are you sure you want to update Lead Price?"
                );
                if (!confirmLeadPrice) {
                  return;
                }
              }
              // console.log(selectedStatus);
              let fdata = new FormData();
              fdata.append("price", leadPrice);
              fdata.append("leadid", leadpricUpdateID);
              fdata.append("user_id", userID);

              try {
                setLoading(true);
                const response = await axios.post(
                  `${WebsiteAPIurl}AgentLeadPrice`,
                  fdata,
                  {
                    headers: {
                      Authorization: RendomTokenfetch,
                      "Content-Type": "multipart/form-data",
                    },
                  }
                );
                console.log(response.data);
                if (response.data.status === "1") {
                  NotifyMessageNoReload(response.data.message, "success");
                  setLeadPrice("");
                  setLeadpricUpdateID("");
                  setOpenPriceUpdateModal(false);
                  if (tableRef.current) {
                    const datatable = tableRef.current.api();
                    datatable.ajax.reload(null, false); // false = keep current page
                  }
                } else {
                  NotifyMessageNoReload(response.data.message, "danger");
                }
              } catch (error) {
                console.error("Error updating lead status:", error);
              } finally {
                setLoading(false);
              }
            }}
            variant="contained"
            color="primary"
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
